export const marqueeConfig = {
  content: [
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
    "Meetusvr -  New Future Shopping with AI",
    "Solve up to 70% of problem with AI",
    "Begin with us and be the first to experience it",
  ],
};
